<template>
  <div>

    <v-row v-if="isLoading">
      <v-col v-for="item in 9" :key="item" cols="4">
        <v-card class="rounded-lg shadow">
          <v-card-text>
            <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else>

      <v-col v-for="(widget,i) in widgets" :key="i" cols="12" lg="4">

        <v-card class="rounded-lg shadow">
          <v-card-text class="py-6">
            <v-row align="center" justify="center">
              <v-col cols="2">
                <v-avatar :color="widget.color" size="42" class="rounded-lg">
                  <v-icon color="white">{{ widget.icon }}</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="10">
                <div class="ml-3 text-no-wrap d-flex align-center justify-space-between">
                  <div>
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ widget.value }}
                    </div>
                    {{ widget.title }}
                  </div>
                  <div v-if="'percent' in widget && widget.percent !== null">
                    <v-progress-circular
                        size="55"
                        width="5"
                        :value="widget.percent"
                        :color="widget.color"
                    >
                      <small class="font-weight-bold">{{ widget.percent }}</small>
                    </v-progress-circular>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      isLoading: false,
      widgets: [],
    }
  },
  methods: {
    getWidgets() {
      this.isLoading = true
      HTTP.get('/v1/supplier-dashboard/widgets').then(res => {
        this.isLoading = false
        this.widgets = res.data.data

      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.getWidgets()
  }
}
</script>

<style scoped>

</style>